import { Outlet } from "react-router-dom";
import SideMenu from "../components/sideMenu";
import { useState } from "react";

const MainLayout = () => {
    const [collapse, setCollapse] = useState(false)
    return (
        <div className="main_layout">
            <div className={collapse ? "side_drawer collapsed" : "side_drawer"}>
                <SideMenu collapse={collapse} setCollapse={setCollapse} />
            </div>
            <div className={collapse ? "right_dashboard collapsed" : "right_dashboard"}>
                <Outlet />
            </div>
        </div>
    );
};
export default MainLayout;